import { render, staticRenderFns } from "./FeesImportedData.vue?vue&type=template&id=e4fc7c68&scoped=true"
import script from "./FeesImportedData.vue?vue&type=script&lang=js"
export * from "./FeesImportedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fc7c68",
  null
  
)

export default component.exports